import type { Shared } from 'types/Shared'
import 'types/Shared'
type State = {
  shared: Shared
}
export const getShared = (state: State): Shared => state.shared || {}
export const getSharedOrNull = (state: State) => state.shared || null
